import { createEntitiesReducer } from 'app/lib/betting/betting-entities';

import {
  APPLY_INTERESTING_MATCHES_STATE,
  fetchInterestingMatches,
  SUBSCRIBE,
  UNSUBSCRIBE,
} from '../actions';

export default createEntitiesReducer(
  process.env.SERVER
    ? {
      REQUEST_ACTION: fetchInterestingMatches.pending.toString(),
      TRIGGER_ACTION: fetchInterestingMatches.fulfilled.toString(),
      FAILURE_ACTION: fetchInterestingMatches.rejected.toString(),
    }
    : {
      REQUEST_ACTION: SUBSCRIBE,
      TRIGGER_ACTION: APPLY_INTERESTING_MATCHES_STATE,
      CLEANUP_ACTION: UNSUBSCRIBE,
    },
);
